<template>
  <div>
    <PageTitle title="POS Shortcuts" :showLoading="isLoading" />
    <v-container fluid class="lighten-12" style="background-color: white">
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-row>
          <v-col cols="12">
            <v-card class="lighten-12 card-content">
              <v-card-title>General</v-card-title>
              <v-container fluid>
                <v-row style="font-family: 'Source Sans Pro', sans-serif">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <v-alert
                          color="cyan"
                          border="left"
                          elevation="2"
                          colored-border
                          icon="mdi-information"
                        >
                          <span> You can customize Shortcuts with Ctrl </span>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row style="margin-left: 8px">
                      <v-row>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Customer Create</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Customer Create"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Create Customer')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Create Customer'
                                  "
                                  :value="setting.add_customer"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div
                              v-if="duplicateFieldName === 'Create Customer'"
                            >
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Customer View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Customer View"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Customer View')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Customer View'
                                  "
                                  :value="setting.customer_view"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Customer View'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Customer Change</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Customer Create"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Change Customer')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Change Customer'
                                  "
                                  :value="setting.change_customer"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div
                              v-if="duplicateFieldName === 'Change Customer'"
                            >
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Brand Views</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Brand View"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="checkValidator($event, 'Brand View')"
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Brand View'
                                  "
                                  :value="setting.brand_view"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Brand View'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Category View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Category View"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Category View')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Category View'
                                  "
                                  :value="setting.category_view"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Category View'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Customer Sales View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Previous Sales"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Previous Sales')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Previous Sales'
                                  "
                                  :value="setting.previous_sales"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Previous Sales'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Payment View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Payment view"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Payment View')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Payment View'
                                  "
                                  :value="setting.payment_view"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Payment View'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Bill View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Bill View"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="checkValidator($event, 'Bill View')"
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Bill View'
                                  "
                                  :value="setting.bill_view"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Bill View'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Susbend Sales View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Susbend sales"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Susbend Sales')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Susbend Sales'
                                  "
                                  :value="setting.suspend_sale"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Susbend Sales'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Quotation View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Quotation View"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Quotation View')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Quotation View'
                                  "
                                  :value="setting.quotation_view"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Quotation View'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Refresh View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Refresh"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="checkValidator($event, 'Referesh')"
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Referesh'
                                  "
                                  :value="setting.refresh"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Referesh'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Change shop View</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Change Shop"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="checkValidator($event, 'Change Shop')"
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Change Shop'
                                  "
                                  :value="setting.change_shop"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Change Shop'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" xs="12" md="4" lg="4">
                          <v-row>
                            <v-col cols="8">
                              <label for=""> <b>Search Product</b></label>
                            </v-col>
                            <v-col cols="2">
                              <b>Ctrl +</b>
                            </v-col>
                            <v-col cols="2">
                              <ValidationProvider
                                v-slot="{ errors }"
                                name="Search Product"
                                rules="required"
                                hide-details="auto"
                              >
                                <v-text-field
                                  hide-details="auto"
                                  :error-messages="errors"
                                  required
                                  @input="
                                    checkValidator($event, 'Search Product')
                                  "
                                  style="margin-top: -6px; margin-left: -27px"
                                  maxlength="1"
                                  :disabled="
                                    ValidatorField &&
                                    duplicateFieldName !== 'Search Product'
                                  "
                                  :value="setting.search_product"
                                  auto-grow
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <div v-if="duplicateFieldName === 'Search Product'">
                              <span style="color: red">
                                <b>Duplicated Entry with {{ Message }}</b>
                              </span>
                            </div>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </ValidationObserver>
      <v-row>
        <v-col cols="12">
          <v-card-actions class="justify-content-end">
            <div>
              <btn-cancel></btn-cancel>
              <v-btn
                depressed
                small
                class="text-white btn_blue btn_medium w-100"
                @click="ValidateUpdateSetting"
                >Update</v-btn
              >
            </div>
          </v-card-actions>
        </v-col></v-row
      >
    </v-container>
  </div>
</template>

<script>
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';

import axios from '@/plugins/axios';
import { mapState } from 'vuex';
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      setting: {
        add_customer: '',
        brand_view: '',
        category_view: '',
        refresh: '',
        change_shop: '',
        change_customer: '',
        search_product: '',
        customer_view: '',
        suspend_sale: '',
        quotation_view: '',
        previous_sales: '',
        payment_view: '',
        bill_view: '',
      },
      temporaryStorage: [],
      Message: '',
      duplicateFieldName: '',
      isLoading: false,
      ValidatorField: false,
    };
  },

  computed: {
    ...mapState(['keyShortcuts']),
  },
  methods: {
    checkValidator(data, storeVal) {
      this.duplicateFieldName = storeVal;
      this.ValidatorField = true;
      if (this.keyShortcuts.add_customer === data) {
        this.Message = 'Create Customer';
      } else if (this.keyShortcuts.brand_view === data) {
        this.Message = 'Brand View';
      } else if (this.keyShortcuts.category_view === data) {
        this.Message = 'Category View';
      } else if (this.keyShortcuts.refresh === data) {
        this.Message = 'Referesh';
      } else if (this.keyShortcuts.change_shop === data) {
        this.Message = 'Change Shop';
      } else if (this.keyShortcuts.change_customer === data) {
        this.Message = 'Change Customer';
      } else if (this.keyShortcuts.search_product === data) {
        this.Message = 'Search Product';
      } else if (this.keyShortcuts.customer_view === data) {
        this.Message = 'Customer View';
      } else if (this.keyShortcuts.suspend_sale === data) {
        this.Message = 'Susbend Sales';
      } else if (this.keyShortcuts.quotation_view === data) {
        this.Message = 'Quotation View';
      } else if (this.keyShortcuts.previous_sales === data) {
        this.Message = 'Previous Sales';
      } else if (this.keyShortcuts.payment_view === data) {
        this.Message = 'Payment View';
      } else if (this.keyShortcuts.payment_view === data) {
        this.Message = 'Payment View';
      } else if (this.keyShortcuts.bill_view === data) {
        this.Message = 'Bill View';
      } else {
        this.updateFieldSetToState(data, storeVal);
        this.ValidatorField = false;
        this.duplicateFieldName = '';
      }
    },
    updateFieldSetToState(data, storeVal) {
      if (storeVal == 'Create Customer') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_CUSTOMER_CREATE', data);
      } else if (storeVal == 'Brand View') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_BRAND_VIEW', data);
      } else if (storeVal == 'Category View') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_CATEGORY_VIEW', data);
      } else if (storeVal == 'Referesh') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_REFRESH', data);
      } else if (storeVal == 'Change Shop') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_CHANGE_SHOP', data);
      } else if (storeVal == 'Change Customer') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_CHANGE_CUSTOMER', data);
      } else if (storeVal == 'Search Product') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_SEARCH_PRODUCT', data);
      } else if (storeVal == 'Customer View') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_CUSTOMER_VIEW', data);
      } else if (storeVal == 'Susbend Sales') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_SUSBEND_SALES_VIEW', data);
      } else if (storeVal == 'Quotation View') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_QUOTATION_VIEW', data);
      } else if (storeVal == 'Previous Sales') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_PREVIOUS_SALES_VIEW', data);
      } else if (storeVal == 'Payment View') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_PAYMENT_VIEW', data);
      } else if (storeVal == 'Bill View') {
        this.$store.commit('UPDATE_KEY_SHORTCUTS_BILL_VIEW', data);
      } else {
        this.ValidatorField = false;
      }
    },
    getPosShortcuts() {
      this.isLoading = true;
      axios
        .get(`settings/pos-shortcut/1`)
        .then((res) => {
          this.isLoading = false;
          this.setting = res.data;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    async ValidateUpdateSetting() {
      // const isValid = await this.$refs.observer.validate();

      if (this.ValidatorField == false) {
        this.isLoading = true;
        this.updatePosShortcuts();
      }
    },
    updatePosShortcuts() {
      axios
        .patch(`settings/pos-shortcut/1`, this.keyShortcuts)
        .then((res) => {
          this.isLoading = false;
          this.$toast.success('POS shortcuts updated successfully');
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to update POS shortcuts');
        });
    },
  },
  async created() {
    this.$store.commit('REMOVE_FILTERDATAS');
    this.$store.commit('UPDATE_PAGINATION_PAGE_SIZE', 15);
    await this.getPosShortcuts();
    setTimeout(() => {
      this.$store.commit('UPDATE_KEY_SHORTCUTS', this.setting);
    }, 400);
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
</style>
